import { gql, TypedDocumentNode } from "@apollo/client";

import { QueryRoleArgs, Role } from "types/generated";

type PreviewPermissionsRoleData = {
  role: Pick<Role, "id" | "name" | "actions">;
};

export const PREVIEW_PERMISSIONS_ROLE: TypedDocumentNode<
  PreviewPermissionsRoleData,
  QueryRoleArgs
> = gql`
  query PreviewPermissionsRole($id: ID!) {
    role(id: $id) {
      id
      name
      actions
    }
  }
`;
